// extracted by mini-css-extract-plugin
export default {"feedbackOptions":"FeedbackOptions_feedbackOptions__y5v0f","feedbackBtn":"FeedbackOptions_feedbackBtn__AIeAq"};